export const TOGGLE_ANALYTICS_PAGE = 'TOGGLE_ANALYTICS_PAGE'

// Game Analytics API
export const FETCH_GAME_ANALYTICS_REQUEST = 'FETCH_GAME_ANALYTICS_REQUEST'
export const FETCH_GAME_ANALYTICS_SUCCESS = 'FETCH_GAME_ANALYTICS_SUCCESS'
export const FETCH_GAME_ANALYTICS_FAILURE = 'FETCH_GAME_ANALYTICS_FAILURE'

// Graph Data API
export const FETCH_GRAPH_DATA_REQUEST = 'FETCH_GRAPH_DATA_REQUEST'
export const FETCH_GRAPH_DATA_SUCCESS = 'FETCH_GRAPH_DATA_SUCCESS'
export const FETCH_GRAPH_DATA_FAILURE = 'FETCH_GRAPH_DATA_FAILURE'

// Fulfillment Analytics API
export const FETCH_FULFILLMENT_ANALYTICS_REQUEST =
  'FETCH_FULFILLMENT_ANALYTICS_REQUEST'
export const FETCH_FULFILLMENT_ANALYTICS_SUCCESS =
  'FETCH_FULFILLMENT_ANALYTICS_SUCCESS'
export const FETCH_FULFILLMENT_ANALYTICS_FAILURE =
  'FETCH_FULFILLMENT_ANALYTICS_FAILURE'

export const SET_ANALYTICS_ENTITY_ID = 'SET_ANALYTICS_ENTITY_ID'
export const SET_ANALYTICS_ENTITY_NAME = 'SET_ANALYTICS_ENTITY_NAME'

